import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
import { Tooltip as TooltipPrimitive } from "radix-ui";
import { cn } from "../cn.js";
/** Wrap the app once. Tooltips open at once (no hover delay), as AutoTooltips' do. */
export function TooltipProvider({ children }) {
    return (_jsx(TooltipPrimitive.Provider, { delayDuration: 0, skipDelayDuration: 0, children: children }));
}
/** Shows on hover and keyboard focus; Escape dismisses it. */
export function Tooltip({ content, children, side = "top", className }) {
    return (_jsxs(TooltipPrimitive.Root, { children: [_jsx(TooltipPrimitive.Trigger, { asChild: true, "data-has-tooltip": "", children: children }), _jsx(TooltipPrimitive.Portal, { children: _jsx(TooltipPrimitive.Content, { side: side, sideOffset: 6, 
                    // The macOS desktop app's window buttons float over the top strip: flip away from it.
                    collisionPadding: { top: document.documentElement.dataset.titlebar === "overlay" ? 40 : 0 }, className: cn("z-50 max-w-xs rounded-md bg-fg px-2 py-1 text-xs font-medium text-bg shadow-overlay", className), children: content }) })] }));
}
//# sourceMappingURL=Tooltip.js.map